//Bilder
import fluegeltor_1 from './fluegeltor_1.jpg';
import fluegeltor_2 from './fluegeltor_2.jpg';
import fluegeltor_3 from './fluegeltor_3.jpg';
import fluegeltor_4 from './fluegeltor_4.jpg';

//Videos
//Videos
const video_1 = "https://www.youtube.com/embed/76kOXcRAhNA";

export const portfolio_fluegeltor = [
    {product_img: fluegeltor_1},
    {product_img: fluegeltor_2},
    {product_img: fluegeltor_3},
    {product_img: fluegeltor_4}
]

export const portfolio_fluegeltor_videos = [
    {product_video: video_1, titel: 'Flügeltor'}
]